module.exports = __webpack_public_path__ + "img/21.ee5e7470.jpg";